import { render, staticRenderFns } from "./KeFuWeiXin.vue?vue&type=template&id=76b1dfc8&scoped=true&"
import script from "./KeFuWeiXin.vue?vue&type=script&lang=js&"
export * from "./KeFuWeiXin.vue?vue&type=script&lang=js&"
import style0 from "./KeFuWeiXin.vue?vue&type=style&index=0&id=76b1dfc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1dfc8",
  null
  
)

export default component.exports